module.exports = __webpack_public_path__ + "img/purple-1-diamond-striped.e9483a91.svg";